import React from 'react';
import PropTypes from 'prop-types';

import StyledEducationShape from './educationShape.style';

const EducationShape = ({ children, contentType, category, clippedClass, ...props }) => {
  const multipleTopics = Array.isArray(category) && category.length > 1;
  const topic = category && category.length === 1 ? category[0].slug : '';

  const multipleTypes = Array.isArray(contentType) && contentType.length > 1;
  const type = contentType && contentType.length === 1 ? contentType[0].slug : '';

  return (
    <StyledEducationShape
      {...props}
      contentType={type}
      multipleTypes={multipleTypes}
      category={topic}
      multipleTopics={multipleTopics}
    >
      <div className={`clipped ${clippedClass}`}>{children}</div>
    </StyledEducationShape>
  );
};

EducationShape.propTypes = {
  children: PropTypes.node,
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  category: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  clippedClass: PropTypes.string.isRequired
};

export default EducationShape;
